const mainheader = $('.site-header');
const firstitem = $('#MainContent .shopify-section:first-child');

if (firstitem.hasClass('index-section--hero') || firstitem.hasClass('index-section--flush')) {  
  mainheader.addClass('heroheaderfirst');
}


var emailvalidated;
var saunavariants;
var splitarray;
var removearray = [];

$( ".footernewsletterinput" ).keyup(function() {

  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  if (regex.test(this.value) == true) {
    
    emailvalidated = true;
    
    if(!($('.newsletterinput').hasClass('emailvalidated'))) {
    $('.footernewslettersubmit').addClass('emailvalidated');
    }
  
  }
  
  else if (emailvalidated == true) {
    $('.footernewslettersubmit').removeClass('emailvalidated');
  }
  
  

});


var newsletterform = $('#newsletterformfooter');
var formaction = $(newsletterform).attr('action');

$(newsletterform).submit(function(e){
  e.preventDefault();
  if (emailvalidated == true) {
    $.ajax({
        url: formaction,
        type: 'POST',
        data: $(newsletterform).serialize(),
        success:function(){
           $('.emailinputfooter').hide();
           $('.footernewslettersubmit').hide();
           $('.signupsuccess').show();
        }
    });
}
});



$( document ).ready(function() {
    if (window.location.href.indexOf("?customer_posted=true") > -1) {
            
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#newsletter").offset().top
    });
  
}
});



$( "body" ).on( "click", ".removesaunaset", function() {

  var variantlist = [];
  var saunatimestamp = $(this).closest('.heatersetitem').data('timestamp');

  jQuery.getJSON('/cart.js', function(cart) {
     $.each(cart.items, function (key, val) {
     if(val.properties["_timestamp"] == saunatimestamp){           
     variantlist.push(`updates["${val.key}"]=0`);
     }
     });
      var urlformat = (variantlist.join("&")).replaceAll('"','');
    
    jQuery.post('/cart/update.js',
  urlformat
)
    .always(function() {
     document.dispatchEvent(new CustomEvent('cart:build'));  
      document.dispatchEvent(new CustomEvent('cart:open'));  
  });

  });

});


$( "#CartDrawerForm" ).on( "click", '#showgiftnotecheck,label[for="CartDrawerSpecialInstructions"]', function() {
  $('#showgiftnotecheck').toggleClass('active');
  $('.cartnotecontain').toggleClass('shownote').toggleClass('hidenote');
  if($('.cartnotecontain').hasClass("hidenote")) {
    debounceFn('clear');
  }
});


function debounce(func, wait) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		clearTimeout(timeout);
		timeout = setTimeout(function() {
		  func.apply(context, args);
    }, wait);
	};
}

debounceFn = debounce(setCartAttribute, 500);

function setCartAttribute(e) {
  if(e == 'clear') {
    var giftRecipient = null;
    var giftEmail = null;
    var giftMessage = null;
    var dateField = null;
  }
  else {
    var giftRecipient = $('.recipientNameField').val();
    var giftEmail = $('.recipientEmailField').val();
    var giftMessage = $('.recipientMessageField').val();
    var dateField = $('.recipientDateField').val();
  }
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        'Recipient Name': giftRecipient,
        'Recipient Email': giftEmail,
        'Personalized Message': giftMessage,
        'Send Date': dateField
      },
      note: `Personalized Message: ${giftMessage}`
    })
  })
  .then(response => response.json());
}

$("#CartDrawerForm").on("keyup", '.giftNoteFieldCart', debounceFn);
$("#CartDrawerForm").on("change", '.recipientDateField', debounceFn);

const mobilemenuitem = $('.site-nav__thumb-menu');


function showmobilemenu() {
  if (!(mobilemenuitem.hasClass('showmobilemenu'))) {
    mobilemenuitem.addClass('showmobilemenu');
  }
}

function hidemobilemenu() {
  if (mobilemenuitem.hasClass('showmobilemenu')) {
    mobilemenuitem.removeClass('showmobilemenu');
  }
}



$(window).resize(function() {
 if ($(window).width() <= 1007) {
  showmobilemenu();
 }
  else {
    hidemobilemenu(); 
  }
});

if ($(window).width() <= 1007) {
showmobilemenu();
}
else {
hidemobilemenu(); 
}


async function updateGiftNote() {
  let giftNoteSection = await fetch(window.Shopify.routes.root + "?sections=gift-note")
  .then(res => res.json())

  const giftNoteData = giftNoteSection['gift-note'];

  var giftDiv = document.createElement('div');
  giftDiv.innerHTML = giftNoteData;
  let innerGiftDiv = giftDiv.querySelector('#shopify-section-gift-note');

  if (innerGiftDiv.querySelectorAll('div').length > 1) {
    document.querySelector('#giftNoteContain').innerHTML = '';
    document.querySelector('#giftNoteContain').appendChild(innerGiftDiv);
    $("#CartDrawerForm").on("keyup", '.giftNoteFieldCart', debounceFn);
    $("#CartDrawerForm").on("change", '.recipientDateField', debounceFn);
  }
  else {
    document.querySelector('#giftNoteContain').innerHTML = '';
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Recipient Name': null,
          'Recipient Email': null,
          'Personalized Message': null,
          'Send Date': null
        },
        note: null
      })
    })
    .then(response => response.json());
  }
}

document.addEventListener('ajaxProduct:added', function(evt) {
  updateGiftNote();
});

document.addEventListener('cart:updated', function(evt) {
  updateGiftNote();
});